@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled"
         [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition) || !preconditionsForEdition}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span [matTooltipPosition]="'below'"
                [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
            <i class="mdi mdi-help-circle tooltip-icon"></i>
          </span>
        }
      </div>
      <div class="field-container fx-flex-100-66-percent fx-layout-row fx-align-center">
        <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)" tabindex="0"
             [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition, 'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}">
          <a [href]="getFieldValue()" (click)="confirmExternalLink($event)">
            {{ getFieldValue() | emptyFieldPipe: {blankFieldValue: appConfig.EMPTY_FIELD_VALUE} }}
          </a>
          @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
            <span
              class="overlay-icon">
              @if (preconditionsForEdition) {
                <i class="mdi mdi-pencil selectable"></i>
              } @else {
                <i [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate"
                   class="mdi mdi-pencil-off tooltip-icon"></i>
              }
            </span>
          }
        </div>
        <mat-icon
          (click)="confirmExternalLink($event)"
          (keyup.enter)="confirmExternalLink($event)"
          fontIcon="open_in_new" class="external-link"
          [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.OPEN_LINK' | translate" tabindex="0">
        </mat-icon>
      </div>
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span [matTooltipPosition]="'below'"
                  [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
              <i class="mdi mdi-help-circle tooltip-icon"></i>
            </span>
          }
        </div>
      }
      <div class="field-container fx-flex-100-66-percent-min-500 fx-layout-col">
        <form autocomplete="off" [formGroup]="form">
          <mat-form-field appearance="outline">
            <mat-label>{{ fieldConfig.label }}</mat-label>
            <input #inputField formControlName="field" matInput type="text"
                   [required]="fieldConfig.customOptions?.required"
                   (keyup.escape)="onEscapeCancel($event)" (keyup.enter)="onActivate($event)">
            @if (fieldConfig.suffixType) {
              <span matTextSuffix>
                {{ fieldConfig.suffixType | translate }}
              </span>
            }
            @if (isCreatingEntity && fieldConfig.tooltip) {
              <span matTextSuffix matTooltipPosition="below"
                    [matTooltip]="fieldConfig.tooltip" #tooltip="matTooltip" (click)="onClickTooltip(tooltip)">
                <i class="mdi mdi-help-circle tooltip-icon"></i>
              </span>
            }
            @for (validator of erroredValidators; track validator.type) {
              <mat-error>
                {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
              </mat-error>
            }
          </mat-form-field>
        </form>
        @if (isSingleField) {
          <div class="save-options">
            <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
              <i class="mdi mdi-close"></i>
            </button>
            <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)" [disabled]="!form.valid"
                    class="button save">
              <i class="mdi mdi-check"></i>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
